export default "__VITE_ASSET__DXi_dK5q__"